import React from 'react';



function Footer() {
  return (
    <div className='container-box-2'>
    <h2>About Me</h2>  
    
    <h4>I really enjoy creating a good group project, 
    the important thing is that we all feel like family.
    I respect the points of view of everyone and with
     many wishes to help, to include myself.</h4> 
     <h4 id="read"> co-workers are life partners, so it's always good to share a favorite place or a great movie.</h4>
     <h4>if you are looking to hire developers with a lot of desire to work to put up 
     the name of your company contact me</h4>
  
    </div>
  )
}

export default Footer
